import { render, staticRenderFns } from "./activatedata.vue?vue&type=template&id=d8ccfb04&scoped=true"
import script from "./activatedata.vue?vue&type=script&lang=js"
export * from "./activatedata.vue?vue&type=script&lang=js"
import style0 from "./activatedata.vue?vue&type=style&index=0&id=d8ccfb04&prod&lang=scss"
import style1 from "./activatedata.vue?vue&type=style&index=1&id=d8ccfb04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8ccfb04",
  null
  
)

export default component.exports